export class subDispositionReceived {
    constructor(subdispositionObj) {
        this.subCanReprogram     = subdispositionObj.CanReprogram;
        this.subDispositionName  = subdispositionObj.Description;
        this.subEndConversation  = subdispositionObj.EndConversation;
        this.subDispositionID    = subdispositionObj.Id;
        this.subOrder            = subdispositionObj.Orden;
        this.subParent           = subdispositionObj.Parent;
    }
}